<div class="app-wrapper">
  <router-outlet />
</div>

<style>
  body, :host {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: #1a1a1a;
    background: #f0eada;
    line-height: 1.8;
  }
  
  html { scroll-behavior: smooth; }
  section { scroll-margin-top: 5rem; }
  
  .app-wrapper {
    min-height: 100vh;
  }
</style>
